/**
 * WHAT THE KEYBOARD CAN LAND ON inside one panel.
 *
 * Two panels ask the question for opposite reasons — `ModalDialog` holds the
 * Tab ring inside itself, `ColumnFilter` only wants the one control its opening
 * should focus — and they must agree about the answer. A control the trap
 * cycles through but the popover would not open on is a control that behaves
 * differently depending on which panel drew it.
 *
 * The selector excludes what is `disabled` and what declares `tabindex="-1"`;
 * the filter after it drops what the selector cannot see, an element whose
 * `tabIndex` was set as a property rather than an attribute. Order is document
 * order, which is the order the Tab key uses for everything this product draws:
 * nothing here carries a positive `tabindex`.
 */
const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'textarea:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',')

export function focusableControls(container: HTMLElement | null): HTMLElement[] {
  if (container === null) {
    return []
  }
  return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(
    (element) => element.tabIndex >= 0,
  )
}
